import React, {ReactNode, useEffect} from 'react';
import SplashScreen from 'react-native-splash-screen';
import {defer} from 'lodash/fp';

import {LoadingView as LoadingComponent} from '/component/base/LoadingView';
import {withStatusBar} from '/provider/StatusBarProvider';
interface LaunchSequenceProviderProps {
  statusBarSetDarkText: () => void;
  statusString: string;
  continueSequence: () => void;
  sequenceCompleted: boolean;
  children: ReactNode;
}
export class LaunchSequenceProvider extends React.PureComponent<LaunchSequenceProviderProps> {
  // @ts-expect-error TS(4114): This member must have an 'override' modifier becau... Remove this comment to see the full error message
  componentDidMount() {
    const {continueSequence} = this.props;
    defer(continueSequence);
    defer(() => SplashScreen.hide());
  }

  // @ts-expect-error TS(4114): This member must have an 'override' modifier becau... Remove this comment to see the full error message
  componentDidUpdate(prevProps: LaunchSequenceProviderProps) {
    const {statusString: prevStatus} = prevProps;
    const {statusString, continueSequence} = this.props;

    if (prevStatus !== statusString) {
      defer(continueSequence);
    }
  }

  getLoadingViewComponent() {
    const {statusBarSetDarkText} = this.props;

    return () => {
      useEffect(() => {
        statusBarSetDarkText();
      }, [statusBarSetDarkText]);

      return <LoadingComponent />;
    };
  }

  getChildrenViewComponent() {
    const {children} = this.props;

    return () => children;
  }

  // @ts-expect-error TS(4114): This member must have an 'override' modifier becau... Remove this comment to see the full error message
  render() {
    const {sequenceCompleted} = this.props;

    const LoadingView = this.getLoadingViewComponent();
    const ChildrenView = this.getChildrenViewComponent();

    return sequenceCompleted ? <ChildrenView /> : <LoadingView />;
  }
}

export default withStatusBar(LaunchSequenceProvider);
